import { render, staticRenderFns } from "./AppMenuPageTemplateEditModal.vue?vue&type=template&id=0bd62bac"
import script from "./AppMenuPageTemplateEditModal.vue?vue&type=script&lang=js"
export * from "./AppMenuPageTemplateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports